export default __webpack_public_path__ + "static/media/header_d.7f0b482e.png";